import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "button" }) {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const setLang = (code) => {
    i18n.changeLanguage(code);
  };

  if (variant === "menu-item") {
    return (
      <div className="text-xs">
        {LANGUAGES.map((l) => (
          <button
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`w-full flex items-center gap-2 px-3 py-1.5 text-left hover:bg-stone-100 ${
              l.code === current.code ? "bg-neutral-950 text-white" : ""
            }`}
          >
            <span>{l.flag}</span>
            <span>{l.label}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher-trigger"
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-sm hover:bg-stone-100 text-xs uppercase tracking-[0.15em] font-semibold transition-colors"
          title="Language"
        >
          <Globe className="w-3.5 h-3.5" strokeWidth={1.75} />
          <span>{current.flag}</span>
          <span className="hidden sm:inline">{current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-sm w-44">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`text-sm cursor-pointer ${
              l.code === current.code ? "font-bold" : ""
            }`}
          >
            <span className="mr-2">{l.flag}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
